export default "__VITE_ASSET__CCINXHvU__"